import React, { useState } from 'react';

const SubscriptionList = ({ subscriptions: propsSubscriptions, total }) => {
    const [isHovered, setIsHovered] = useState(false);

    const getIconImage = (type) => {
        const baseUrl = 'https://cdn.clikkle.com/images/';
        switch (type?.toLowerCase()) {
            case 'file':
            case 'files':
                return `${baseUrl}files/logo/2025/clikkle%20files.png`;
            case 'esign':
                return `${baseUrl}e-sign/logo/2025/clikkle%20esign.png`;
            case 'projects':
                return `${baseUrl}projects/logo/2025/clikkle%20projects.png`;
            case 'app':
            case 'worksuite':
                return `${baseUrl}worksuite/2025/clikkle%20worksuite.png`;
            case 'campaigns':
                return `${baseUrl}campaigns/logo/2025/clikkle%20campaigns.png`;
            case 'chat':
                return `${baseUrl}chat/logo/2025/clikkle%20chat.png`;
            case 'hr':
                return `${baseUrl}hr/logo/2025/clikkle%20hr.png`;
            default:
                return `${baseUrl}worksuite/2025/clikkle%20worksuite.png`;
        }
    };

    // Transform subscriptions data
    const subscriptions = propsSubscriptions?.map((sub, index) => ({
        id: sub._id,
        name: sub.planName || sub.productName || `Subscription ${index + 1}`,
        icon: getIconImage(sub.type || sub.productName || '')
    })) || [];

    // Container styles
    const containerStyle = {
        position: 'relative',
        width: 'auto',
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        paddingLeft: '12px',
        color: 'white',
    };

    // Title styles
    const titleStyle = {
        fontSize: '16px',
        fontWeight: 500,
        marginBottom: '8px',
        color: '#fff'
    };

    // Icon bar styles - when not hovered
    const iconBarStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        marginBottom: '4px',
    };

    // Icon styles for both compact and expanded views
    const iconContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.12)',
        borderRadius: '4px',
        width: '24px',
        height: '24px',
        padding: '4px',
        overflow: 'hidden'
    };

    const iconImgStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'contain'
    };

    // Expanded dropdown styles
    const expandedListStyle = {
        position: 'absolute',
        left: '12px',
        top: '0',
        width: '180px',
        backgroundColor: '#1a1a1a',
        zIndex  : 1000,
        borderRadius: '8px',
        padding: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
        display: isHovered ? 'block' : 'none',
    };

    // Item styles for expanded list
    const listItemStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '4px 0',
        fontSize: '14px',
        color: '#fff'
    };

    // For the "+" icon showing more items
    const plusIconStyle = {
        ...iconContainerStyle,
        backgroundColor: 'transparent',
        color: '#3ea6ff',
        fontWeight: 'bold',
    };

    if (!subscriptions || !subscriptions.length) {
        return (
            <div style={containerStyle}>
                <div style={{ fontSize: '14px', color: '#666', textAlign: 'center', padding: '20px' }}>
                    {total ? `${total} Subscriptions` : 'No active subscriptions'}
                </div>
            </div>
        );
    }

    return (
        <div
            style={containerStyle}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >

            {/* Compact icon bar - shows only first 5 icons plus "+" if there are more */}
            <div style={iconBarStyle}>
                {subscriptions.slice(0, 5).map((sub) => (
                    <div key={sub.id} style={iconContainerStyle}>
                        <img src={sub.icon} alt={sub.name} style={iconImgStyle} />
                    </div>
                ))}

                {subscriptions.length > 5 && (
                    <div style={plusIconStyle}>
                        +{subscriptions.length - 5}
                    </div>
                )}
            </div>

            {/* Expanded dropdown that shows on hover */}
            <div style={expandedListStyle}>
                <div style={titleStyle}>Subscriptions</div>

                {subscriptions.map((sub) => (
                    <div key={sub.id} style={listItemStyle}>
                        <div style={iconContainerStyle}>
                            <img src={sub.icon} alt={sub.name} style={iconImgStyle} />
                        </div>
                        <span>{sub.name}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SubscriptionList;